"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
const react_1 = require("react");
const useWindowSize = (delay = 500) => {
    const [size, setSize] = (0, react_1.useState)([0, 0]);
    (0, react_1.useLayoutEffect)(() => {
        let timeoutID;
        const handleResize = () => {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(() => setSize([window.innerWidth, window.innerHeight]), delay);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(timeoutID);
            window.removeEventListener('resize', handleResize);
        };
    }, [delay]);
    return size;
};
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=index.js.map